import { NullableType } from '@/models'

export const toFixed = (value: NullableType<number>): string => {
  if (!value) {
    return '0'
  }

  return (+value).toFixed(2)
}
